<template>
	<div>
		<div class="grid-940-1 mt20">
			<div class="loginpage-left" id="div_left">
			</div>
			<div class="loginpage-right">
				<form >
					<input type="hidden" name="backUrl" value="">
					<input type="hidden" name="qualifyType" value="002001">
					<input type="hidden" name="clientType" value="uc">
					<input type="hidden" name="exchangeId" value="">
					<div class="loginpage-title"><span class="Login_Span_1" id="tagPwd" v-bind:class="{'Cur': isPwdActive }" v-on:click="changeTagFun('tagPwd')">密码登录</span>
												 <span class="Login_Span_2" id="tagMobile" v-bind:class="{'Cur': isMobileActive }" v-on:click="changeTagFun('tagMobile')">手机验证码登录</span></div>
					<table v-if="changeTag === 'tagPwdContent'" width="100%" border="0" cellspacing="0" cellpadding="0" class="loginpage-table Cur">
						<tbody>
							<tr>
								<th class="login_th">
									<font id="account_font" class="loginpage-star">*</font>登录账号 ：</th>
								<td class="login_td">
									<input type="text" id="account" name="account" value="" class="input-txt" maxlength="256" style="color:#000000">
								</td>
							</tr>
							<tr>
								<th class="login_th">
									<font id="p_font" class="loginpage-star">*</font>登录密码：</th>
								<td class="login_td">
									<input id="password" name="password" value="" type="password" class="input-txt" maxlength="20">
								</td>
							</tr>
							<tr>
					          <th>&nbsp;</th>
					          <td>
					          	<input class="btn-loginpage cur" type="button" v-on:click="login()" value="登 录" >&nbsp;&nbsp;&nbsp;&nbsp;
					          </td>
					        </tr>
						</tbody>
					</table>
					<table v-if="changeTag === 'tagMobileContent'" width="100%" border="0" cellspacing="0" cellpadding="0" class="loginpage-table Cur">
						<tbody>
							<tr>
								<th class="login_th_1">
									<font id="account_font" class="loginpage-star">*</font>手机号 ：</th>
								<td class="login_td_1">
									<input type="text" id="mobile" name="mobile" value="" class="input-txt" maxlength="256" style="color:#000000">
								</td>
							</tr>
							<tr>
								<th class="login_th_1">
									<font id="p_font" class="loginpage-star">*</font>验证码：</th>
								<td class="login_td_1">
									<input id="checkCode" name="checkCode" value="" type="password" class="input-txt" maxlength="20">
									<button type="button" id="buttonView" v-on:click="sendCode()" class="mui-btn mr10 f12 login_button">获取验证码</button>
								</td>
							</tr>
							<tr>
					          <th>&nbsp;</th>
					          <td>
					          	<input class="btn-loginpage cur" type="button" v-on:click="mobileLogin()" value="登 录" >&nbsp;&nbsp;&nbsp;&nbsp;
					          </td>
					        </tr>
						</tbody>
					</table>
				</form>
			</div>
			<div class="clr"></div>
		</div>
	</div>
</template>
<script>
	/*引入Vue框架*/
	import Vue from 'vue'
	/*引入资源请求插件*/
	import VueResource from 'vue-resource'
	/*使用VueResource插件*/
	Vue.use(VueResource)
	//import jQuery from "../../../static/js/jquery.min.js"
	import jQuery from 'jquery';
	import API from "../../../static/api/api.js"
	import md5 from 'js-md5';
//	import md5 from "../../../static/js/md5.min.js";
	export default {
		name: 'login',
		data() {
			return {
				changeTag : "tagPwdContent",
                isPwdActive : true,
                isMobileActive : false,
                backUrl:'index'
			}
		},
		components: {

		},
		methods: {
			changeTagFun:function(id){
        		var flag = "tagPwdContent";
        		if(id == "tagMobile"){
        			flag = "tagMobileContent";
        			this.isPwdActive = false;
        			this.isMobileActive = true;
        		}else{
        			this.isPwdActive = true;
        			this.isMobileActive = false;
        		}
        		this.changeTag = flag;
        	},
        	login:function(){
        			var that = this;
        			var account = jQuery("#account").val();
					var password = jQuery("#password").val();
					if(account == "") {
						alert('请输入账号');
						return false;
					}
					if(password == "") {
						alert('请输入密码');
						return false;
					}
					var pwd_md5 = md5(password);
					API.login(account,pwd_md5,function(ret){
						if(ret.optStatus != undefined && ret.optStatus) {
							localStorage.setItem('mobile',ret.mobile);
							that.$router.push({ name: 'index'});
						}
					});
        	},
        	
        	mobileLogin:function(){
        		var that = this;
        		var mobile = jQuery("#mobile").val();
				var checkCode = jQuery("#checkCode").val();
				if(mobile == "") {
					alert('请输入手机号');
					return false;
				}
				if(checkCode == "") {
					alert('请输入验证码');
					return false;
				}
				API.mobileLogin(mobile,checkCode,function(ret){
					if(ret.code == 'success') {
						localStorage.setItem('mobile',mobile);
						that.$router.push({ name: 'index'});
					}else{
						alert(ret.msg);
					}
				});
        	},
        	
        	sendCode:function(){
        		var that = this;
        		var buttonView = jQuery("#buttonView");
				if(that.leftTime > 0) {
					alert('请在' + that.leftTime + '秒后再次获取');
					return false;
				}
				var mobile = jQuery("#mobile").val();
				if(mobile == "") {
					alert('请输入手机号');
					return false;
				}
				buttonView.attr("disabled", true);
				that.leftTime = 60;
				var result_id = setInterval(this.countDown, 1000,buttonView);
				API.sendCode(mobile,function(ret){
					if(ret.code == "success") {
							//confirm('短信发送成功', '提示', ['确定'], function(e) {});
					}else{
						alert(ret.msg);
						clearInterval(result_id);
						that.leftTime = '0';
						buttonView.attr("disabled", false);
					}
				});
        	},
        	
        	countDown:function(obj) {
				if(this.leftTime > 0) {
					this.leftTime = this.leftTime - 1;
					obj.text("剩余" + this.leftTime + "秒");
				} else {
					obj.attr("disabled", false);
					obj.text("获取验证码");
				}
			}
		},
		mounted() {

		}
	}
</script>

<style scoped>
.mt20 {
    margin-top: 20px;
}
.grid-940-1 {
    width: 898px;
    padding: 20px;
    background: #fff;
    border: solid 1px #e7e7e7;
    margin: 0 auto;
    margin-top: 100px;
    height: 400px;
}
.loginpage-left {
    width: 420px;
    height: 380px;
    float: left;
    background: url(../../../static/images/login-left-img.png) center no-repeat;
}
.grid-940-1 .loginpage-right {
    width: 410px;
    margin-left: 30px;
    box-shadow: 0 0 5px 1px #ddd;
    margin-top: 90px;
}
.loginpage-right {
    width: 370px;
    float: left;
}
.grid-940-1 .loginpage-title {
    padding: 0;
}
.loginpage-title {
    padding: 30px;
    height: 30px;
}
.grid-940-1 .loginpage-title span.Cur {
    border-bottom-color: #ff4600;
    color: #ff4600;
    font-size: 16px;
    font-weight: bold;
    background: #fff;
}
.grid-940-1 .loginpage-title span {
    padding: 0;
    width: 50%;
    display: block;
    float: left;
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-bottom: 2px solid #ddd;
    cursor: pointer;
    background: #efefef;
}
.loginpage-title span {
    color: #999;
    padding-top: 20px;
    padding-left: 5px;
}
.grid-940-1 .loginpage-table.Cur {
    display: block;
}

.grid-940-1 .loginpage-table {
    margin-top: 45px;
    margin-bottom: 35px;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}
.loginpage-star {
    display: none;
}
.grid-940-1 .loginpage-table .input-txt {
    padding: 1px;
    padding-left: 5px;
}
.loginpage-table .input-txt {
    width: 240px;
}
.loginpage-table .input-txt, .loginpage-table .input-txt-2 {
    height: 27px;
    border: solid 1px #cdcdcd;
}
.input-txt {
    width: 240px;
}
.input-txt, .input-txt-2 {
    height: 27px;
    border: solid 1px #cdcdcd;
}
input {
    outline: none;
    background: #fff;
    font-family: "Microsoft YaHei";
}
input, select, label {
    vertical-align: middle;
}
.grid-940-1 .loginpage-table .inpt {
    padding: 5px;
    padding-left: 5px;
    background: #fff;
}
.inpt {
    padding: 2px;
    border: 1px solid #C6C6C6;
    background: url(../../../static/images/inp_bg.png) 0 0 repeat-x;
}
.loginpage-table .btn-loginpage {
    width: 240px;
    height: 36px;
    background: url(../../../static/images/register_submit.gif) no-repeat;
    overflow: hidden;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
}
.cur {
    cursor: pointer;
}
input {
    outline: none;
    background: #fff;
    font-family: "Microsoft YaHei";
}
.grid-940-1 .Table_2 {
    margin-top: 0;
    margin-bottom: 0;
}
#login_container {
    margin-left: 35px;
}
.login_th{
	padding-left: 30px;
	padding-right: 5px;
}
.login_td{
	padding-top: 5px;
    padding-bottom: 5px;
}
.login_th_1{
	padding-left: 20px;
	padding-right: 5px;
}
.login_td_1{
	padding-top: 5px;
    padding-bottom: 5px;
}
.login_button{
	padding: 5px;
    border: solid 1px #afa59e;
}
</style>


// WEBPACK FOOTER //
// src/page/login/login.vue?55f9587d